import { render, staticRenderFns } from "./FMCard.vue?vue&type=template&id=0fe79a6a&scoped=true&"
import script from "./FMCard.vue?vue&type=script&lang=js&"
export * from "./FMCard.vue?vue&type=script&lang=js&"
import style0 from "./FMCard.vue?vue&type=style&index=0&id=0fe79a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe79a6a",
  null
  
)

export default component.exports